<div xmlns="http://www.w3.org/1999/html">
  <div>
    <div>
      Please provide a brief explanation for the sudden change:
    </div>
    <div class="col-12 col-md-12 col-lg-12" style="padding-left: 0; padding-top: 10px; padding-bottom: 20px">
      <textarea [(ngModel)]="explanation" class="form-control" id="dateReported"> </textarea>
    </div>
    <br>
    <br>
    <br>
  </div>
  <div class="buttons-margin-left pull-right">
    <button (click)="closePopUp()" class="btn btn-outline-primary">
      <i aria-hidden="true" class="fa fa-close pr-2"></i>
      Cancel
    </button>
    <button (click)="onSubmit()" [disabled]="explanation === ''" class="btn btn-outline-success" style="margin-left: 5px">
      <i aria-hidden="true" class="fa fa-check-circle pr-2"></i>
      Confirm
    </button>
    <br>
    <br>
  </div>
</div>
